module.exports = __webpack_public_path__ + "img/wendu-1.png";